/* eslint-disable import/first */
import React, { useState, useEffect, useCallback } from 'react';
import { Divider, Grid, Radio, ListItemSecondaryAction } from '@material-ui/core';
import { MdErrorOutline } from '@react-icons/all-files/md/MdErrorOutline';
import { FormattedMessage, useIntl } from 'react-intl';
import cashorcard from './images/cod.svg';
import css from './index.module.scss';
import Redux from 'spwa-ui-library/esm/redux';
import {
  getCurrentProfile,
  selectCurrentCountry,
} from 'spwa-ui-library/esm/redux/store/profileSlice';
import { sendOtp } from 'spwa-ui-library/esm/redux/store/authSlice';
import { selectCountryValidations } from 'spwa-ui-library/esm/redux/store/configSlice.js';
import { useNavigate } from '@reach/router';
const { useSelector, useDispatch } = Redux;
const PayonDelivery = ({
  paymentMethodConst,
  setSubPayment,
  paymentModeObj,
  checked,
  onClickPodRadio,
  selectedValue,
  id,
  enableBinPromo,
  setBinPromoPopup,
  setSelectedMethod,
}) => {
  const [podMode, setPodMode] = useState('');
  const [selectedVal, setSelectedVal] = useState(null);
  const currentProfile = useSelector(getCurrentProfile);
  const dispatch = useDispatch();
  const intl = useIntl();
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const navigate = useNavigate();

  const fetchPaymentMethodName = useCallback(
    (id) => {
      const op = paymentMethodConst.filter((each) => {
        return each.name === id;
      });
      return op[0].shortName;
    },
    [paymentMethodConst]
  );

  // eslint:fix map is replaced with forEach
  const getDefaultModeName = () => {
    console.log(`inside - getDefaultModeName -- `, JSON.stringify(newData, null, 1));
    return newData?.forEach((each) => {
      if (each.active === 1 && each.default === 1) {
        paymentMethodConst.filter((next) => {
          if (next.name === each.name) {
            setPodMode(next.shortName);
          }
          return null;
          // eslint:fix null is returned where filter search is used
        });
      }
    });
  };
  const getDefaultModeID = () => {
    return newData?.forEach((each) => {
      if (each.active === 1 && each.default === 1) {
        setSubPayment(each.id);
      }
    });
  };

  useEffect(() => {
    getDefaultModeName();
    getDefaultModeID();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const newData = paymentModeObj.filter((each) => {
    return each.id === id;
  });
  const changeMode = React.useCallback((value) => {
    const modval = fetchPaymentMethodName(value.name);
    setPodMode((prev) => modval);
    setSelectedVal(value.id);
    onClickPodRadio(100);
    setSubPayment(value.id);
  });
  const onPodClick = () => {
    if (enableBinPromo) {
      setBinPromoPopup(true);
      setSelectedMethod(100);
    } else {
      currentProfile.phnVerified == 1 && onClickPodRadio(id);
    }
  };

  const handleVerify = () => {
    dispatch(
      sendOtp({
        cCode: currentProfile?.cCode,
        phnNo: currentProfile?.phnNo,
        otpVia: 'PHONE',
        sendOtpVia: 'SOCIAL',
        country: currentProfile?.country.toUpperCase(),
      })
    )
      .then((resp) => {
        navigate(`/${intl.locale}/verifyOTP`, {
          replace: true,
          state: {
            cCode: countryValidations?.defaultCCode,
            phnNo: currentProfile?.phnNo,
            component: 'login',
            isDisableEdit: true,
          },
        });
      })
      .catch((error) => {
        // TODO: Handle send otp error
      });
  };
  return (
    <Grid className={checked ? css.rootpod : css.rootpod1}>
      <Grid className={css.headerArea} onClick={onPodClick}>
        <img src={cashorcard} />
        <span className={css.ccodTitle}>
          <span
            className={[css.heading, currentProfile.phnVerified == 0 && css.disabledText].join(' ')}
          >
            <FormattedMessage id="checkout_pod" defaultMessage="Pay On Delivery" />
          </span>
          {currentProfile.phnVerified == 0 && (
            <p className={css.warningText}>
              <FormattedMessage
                id="VerifyMobileNo"
                defaultMessage="Verify your mobile number to activate cash on delivery"
              />
            </p>
          )}
        </span>

        {podMode && podMode !== '' ? (
          <Grid className={css.selectedRadio}>
            <span className={checked ? css.radioTag : css.invsbleContent}>{podMode}</span>
          </Grid>
        ) : (
          ''
        )}

        {currentProfile.phnVerified == 1 ? (
          <Radio className={css.updateColor} checked={checked} />
        ) : (
          <span className={css.verifyButton} onClick={handleVerify}>
            <FormattedMessage id="verify_checkout" defaultMessage="Verify" />
          </span>
        )}
      </Grid>
      <Grid className={(checked || newData?.length <= 1) && css.hideContent}>
        <Divider />
      </Grid>
      <Grid className={checked && newData?.length > 1 ? css.radioContainer : css.hideContent}>
        {newData?.map((each) => {
          const checked =
            (each.default === 1 && selectedVal === null) ||
            (selectedVal !== null && selectedVal === each.id);
          return (
            <Grid>
              <Grid className={each.active === 1 ? css.buttonArea : css.buttonAreaDisable}>
                <ListItemSecondaryAction className={css.radio}>
                  <Radio
                    className={css.updateColor}
                    color="primary"
                    onChange={() => changeMode(each)}
                    checked={checked}
                  />
                </ListItemSecondaryAction>
                <span className={css.radioText}>{fetchPaymentMethodName(each.name)}</span>
              </Grid>

              <Grid className={css.codWarningContainer}>
                <span className={css.codWarningText}>
                  {each.active === 0 && (
                    <FormattedMessage
                      id="checkout_ThisNotAvailable"
                      defaultMessage="This is not available at this moment"
                    />
                  )}
                </span>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid className={checked && newData?.length > 1 ? css.warningContainer : css.hideContent}>
        <MdErrorOutline size={15} fill="#FB8D45" />
        <span className={css.warningText}>
          {' '}
          <FormattedMessage
            id="checkout_selectedPaymentCannotChanged"
            defaultMessage="The selected payment mode cannot be changed later."
          />
        </span>
      </Grid>
    </Grid>
  );
};

export default PayonDelivery;
